export enum TaskType {
  form = 'form',
  prompt = 'prompt',
}
